<script>
import { VSelect } from 'vuetify/lib'

export default {
  name: 'InputSelect',
  components: {
    VSelect
  },
  methods: {
    selected ($e) {
      this.$emit('input', $e instanceof Event ? $e.target.value : $e)
    }
  }
}
</script>

<template>
  <div
    class="app-input-select"
  >
    <component
      :is="$device.isMobile ? 'select' : 'VSelect'"
      :class="$device.isMobile ? 'app-input-select__select v-input v-text-field v-text-field--outlined' : ''"
      v-bind="[$props, $attrs]"
      @change="selected"
    >
      <template v-if="$device.isMobile">
        <option
          v-for="item in $attrs.items"
          :key="item"
          :value="item"
          :selected="item === $attrs.value"
        >
          {{ item }}
        </option>
      </template>
    </component>
    <VIcon
      v-if="$device.isMobile"
      class="app-input-select__icon"
    >
      $dropdown
    </VIcon>
  </div>
</template>

<style lang="scss">
  .app-input-select {
    position : relative;
    z-index: 0;

    &__select {
      padding: 14px 40px 14px 10px;
      border: 1px solid map-deep-get($material-light, 'text-fields', 'outlined');
      width: 100%;
      border-radius: 3px;
      outline: none;
    }

    &__icon.v-icon {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      z-index : -1;
    }
  }
</style>
